import type {Nullable} from '../utility-types';
import type {DateTimeObj, NaiveDateTimeObj} from './types';

import {not} from '../conditionalUtils';
import {isValidDateTimeString} from './isValidDateTimeString';

/**
 * Very useful and performant if we want to sort records by DateTimeObj
 */
export const dateTimeObjToInt = (
  obj?: Nullable<DateTimeObj | NaiveDateTimeObj | string>,
) => {
  if (typeof obj === 'string') {
    if (not(isValidDateTimeString(obj))) {
      return 0;
    }

    return new Date(obj).getTime();
  }

  if (!obj) {
    return 0;
  }

  return (
    obj.year +
    obj.month +
    obj.day +
    (obj.hour || 0) +
    (obj.minute || 0) +
    (obj.second || 0) +
    (obj.microsecond || 0)
  );
};
